import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from '../Footer'
import config from "../../config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Left_menu from "./Left_menu";

const Developer_settings = () => {
  
    let navigate = useNavigate()
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
     }
   const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const[state,setState]= React.useState({shipment_list:"",customer_id:"",isLoading:true})
    const [products, setProducts] = useState([]);
    const [companyDetail, setCompanyDetail] = React.useState([]);

    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 5000
  })
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
        homeSection.classList.toggle('sidebar-closed');
    }
};
    
    React.useEffect(() => {
       shipment_list();
       product_list();
       company_detail();
    }, [])

    const shipment_list=(status)=>{
        let dataToSend = {customer_id : userData.customer_id
    };
   
      // console.log("datatoSend",dataToSend)
      let url = config.apiUrl + '/user/user_secret_key';
      
      axios.post(url, dataToSend, { headers: config.headers })
          .then((res) => {
            // console.log("responseJson => ", res);
            setState({shipment_list:res.data.output,customer_id:res.data.customer_id,isLoading:false})
         
          })
          .catch((error) => {
             
              // console.log(error);
          });    

    }

    const product_list = () => {
        let dataToSend = {
          mode: "Domestic",
          order_type: "Forward"
        };
      
        let url = config.apiUrl + "/shipment/all_product_list";
      
        axios
          .post(url, dataToSend, { headers: config.headers })
          .then((res) => {
            setProducts(res.data.output || []);
          })
          .catch(() => {});
      };
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
          .then(() => {
            // console.log('Text copied to clipboard');
            Toast.fire({
                background:"rgb(8, 88, 185)",
                type: 'success',
                title: "Text copied to clipboard",
                color:"white"
              });
             
            // You can also show a success message or perform any other desired action here
          })
          .catch((error) => {
            // console.error('Error copying text to clipboard:', error);
            // You can show an error message or handle the error in any appropriate way here
          });
      };
      const handleCopy1 = (text) => {
        navigator.clipboard.writeText(text)
          .then(() => {
            // console.log('Text copied to clipboard');
            Toast.fire({
                background:"rgb(8, 88, 185)",
                type: 'success',
                title: "Text copied to clipboard",
                color:"white"
              });
             
            // You can also show a success message or perform any other desired action here
          })
          .catch((error) => {
            // console.error('Error copying text to clipboard:', error);
            // You can show an error message or handle the error in any appropriate way here
          });
      };

      const company_detail = () =>{
        let full_api = config.apiUrl + `/user/get_company_info_api`;
        let sendData = {};
      
        axios.post(full_api, sendData, { headers: config.headers }).then(res => {
            setCompanyDetail(res.data.companyDetail || []);
         
        }).catch((e) => {
        
        })
      }
  return (
    <div>
     
     
      <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="home-section">
         
          <Header/>
                {/* Desktop Nav + Create Button */}
                <div className="row justify-content-between">
                  <div className="col-12 col-md-3 desk_nav">
                    <div className="d-flex">
                      {/* <a href="javascript:window.history.back();" className="back_btn"><i className="bi bi-arrow-90deg-left"></i></a> */}
                      <h2>Developer Settings</h2>
                    </div>
                  </div>
                  <section class="py-4 bg-light">
                  <div className="card mb-4 shadow-sm border-0">
  <div className="card-body">
    <h4 className="mb-2">Developer Overview</h4>
    <p className="mb-1">
      This page contains credentials, API tools, and courier configuration required
      to integrate Kourierwale APIs.
    </p>
    <span className="badge bg-danger me-2">Production Only</span>
    <span className="text-muted">Sandbox environment is not available</span>
  </div>
</div>
        
        {/* <div class="container width_custom bg-white mt-3  p-3">
            <h3>Develoepr Settings</h3>
            <p>Please use below key/token to access and authrize the apis.</p>
         
            <h4 class="pt-3">Key:</h4>
            <table class="table table-responsive">
                <thead>
                  <tr>
                    <th>Particular</th>
                    <th>Value</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Secret Key</td>
                    <td>{state.shipment_list}</td>
                    <td><a onClick={()=>handleCopy(state.shipment_list)} class="btn btn-primary">Copy</a> </td>
                  </tr>
                </tbody>
              </table>

              <h4 class="pt-3">Customer ID:</h4>
            <table class="table table-responsive">
                <thead>
                  <tr>
                    <th>Particular</th>
                    <th>Value</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Customer Id</td>
                    <td>{state.customer_id}</td>
                    <td><a onClick={()=>handleCopy1(state.customer_id)} class="btn btn-primary">Copy</a></td>
                  </tr>
                </tbody>
              </table>
        </div> */}
        
        <div className="card mb-4 shadow-sm border-0">
  <div className="card-body">
    <h4 className="mb-3">API Credentials</h4>

    <div className="row mb-3">
      <div className="col-md-3 fw-bold">Customer ID</div>
      <div className="col-md-7 text-break">{state.customer_id}</div>
      <div className="col-md-2">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => handleCopy1(state.customer_id)}
        >
          Copy
        </button>
      </div>
    </div>

    <div className="row">
      <div className="col-md-3 fw-bold">Secret Key</div>
      <div className="col-md-7 text-break">{state.shipment_list}</div>
      <div className="col-md-2">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => handleCopy(state.shipment_list)}
        >
          Copy
        </button>
      </div>
    </div>
  </div>
</div>
<div className="card mb-4 shadow-sm border-0">
  <div className="card-body">
    <h4 className="mb-2">Postman Collection</h4>
    <p className="mb-3">
      Use our official Postman collection to test and integrate APIs.
      This collection points to <b>Production APIs</b>.
    </p>

    <a
  href={companyDetail?.[0]?.postman_url || "#"}
  target="_blank"
  rel="noopener noreferrer"
  className={`btn btn-primary ${!companyDetail?.[0]?.postman_url ? "disabled" : ""}`}
>
  Open Postman Collection
</a>
  </div>
</div>
<div className="card shadow-sm border-0">
  <div className="card-body">
    <h4 className="mb-3">Available Couriers</h4>
    <p className="text-muted">
  Use the below IDs while creating shipments. These values are required
  in the Create Shipment API.
  <br />
  <b>Note:</b> If the <b>Courier ID</b> is empty for any courier, you do not
  need to pass <code>courier_id</code> in the Create Shipment API.
</p>

    <div className="table-responsive">
      <table className="table table-hover align-middle">
        <thead className="table-light">
          <tr>
            <th>Courier Name</th>
            <th>Product ID</th>
            <th>Carrier ID</th>
            <th>Courier ID</th>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 ? (
            products.map((item, index) => (
              <tr key={index}>
                <td className="fw-semibold">{item.product_name}</td>
                <td>{item.product_id}</td>
                <td>{item.carrier_id}</td>
                <td>{item.product_type||"N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center text-muted">
                No courier data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>
       
</section>    
              </div>
             
           
          
          <Footer />
        
      
    </div>
    </div>
  );
};

export default Developer_settings;
